module.exports = __webpack_public_path__ + "static/absolute-header-structure-45f9a0a2abbcbfc7dd2293c139f04d17.jpg";